export const pagination = (data, currentPage, itemsPerPage) => {
  return (
    data?.length > 0 &&
    data?.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage)
  );
};
